import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F4FBF8] text-[#17231F]">
      <SEO page="home" />
      <Header />
      <main id="main-content">
        <Hero />
        <Features />
      </main>
      <Footer />
    </div>
  );
}
